import { AxiosResponse } from 'axios';

import { API_BASE_PATH } from '@/config';
import { axios } from '@/lib/axios';

export const getAdditionalCompensationsXLS = (
  page?: string,
  sort?: string,
  type?: string,
  createdBetween?: string
): Promise<AxiosResponse<Blob, any>> =>
  axios.get(`${API_BASE_PATH}/workers/additional-compensations`, {
    params: {
      'filter[status]': 'submitted',
      'filter[createdBetween]': createdBetween,
      'filter[type]': type,
      sort,
      page,
    },
    headers: {
      accept: 'application/octet-stream',
    },
    responseType: 'blob',
  });
